import messages from './messages';
import { LabelFormat } from '../../../../../components/layout-selector/contants';
import {
  getLayoutOptionsMapped,
  getCustomLayoutOptionsMapped,
  getNewLayoutOptionsMapped,
} from '../../../../../components/layout-selector/utils';

export const defaultLabelFormatValue = LabelFormat.FourBySix;

export const customLabelLayoutSettingOptions = getCustomLayoutOptionsMapped().map((layout) => ({
  layoutId: layout.value,
  name: layout.messageDescriptor.defaultMessage,
}));

// TODO: [SPD-19601]: Remove getNewLayoutOptionsMapped when feature flag is removed
export const allLabelFormats = [...getLayoutOptionsMapped(), ...getCustomLayoutOptionsMapped(), ...getNewLayoutOptionsMapped()];

export const labelDpis = [
  {
    value: '300',
    messageDescriptor: messages.label300Dpi,
  },
  {
    value: '203',
    messageDescriptor: messages.label203Dpi,
  },
];

export const batchSummaryOptions = [
  {
    value: '0',
    messageDescriptor: messages.batchSummaryNone,
  },
  {
    value: '1',
    messageDescriptor: messages.batchSummaryBeginning,
  },
  {
    value: '2',
    messageDescriptor: messages.batchSummaryEnd,
  },
];

export const labelOrderBys = [
  {
    value: 'ShipSequence asc',
    messageDescriptor: messages.orderLabelsByNone,
  },
  {
    value: 'OrderDate desc',
    messageDescriptor: messages.orderByOrderDateDesc,
  },
  {
    value: 'OrderDate asc',
    messageDescriptor: messages.orderByOrderDateAsc,
  },
  {
    value: 'PayDate desc',
    messageDescriptor: messages.orderByPaidDateDesc,
  },
  {
    value: 'PayDate asc',
    messageDescriptor: messages.orderByPaidDateAsc,
  },
  {
    value: 'ShipName asc',
    messageDescriptor: messages.orderByRecipientNameAsc,
  },
  {
    value: 'ShipName desc',
    messageDescriptor: messages.orderByRecipientNameDesc,
  },
  {
    value: 'OrderNumber asc',
    messageDescriptor: messages.orderByOrderNumberAsc,
  },
  {
    value: 'OrderNumber desc',
    messageDescriptor: messages.orderByOrderNumberDesc,
  },
  {
    value: 'ItemSku asc',
    messageDescriptor: messages.orderByItemSkuAsc,
  },
  {
    value: 'ItemSku desc',
    messageDescriptor: messages.orderByItemSkuDesc,
  },
  {
    value: 'ItemName asc',
    messageDescriptor: messages.orderByItemNameAsc,
  },
  {
    value: 'ItemName desc',
    messageDescriptor: messages.orderByItemNameDesc,
  },
  {
    value: 'WarehouseLocation asc',
    messageDescriptor: messages.orderByWarehouseLocationAsc,
  },
  {
    value: 'WarehouseLocation desc',
    messageDescriptor: messages.orderByWarehouseLocationDesc,
  },
];

export const labelMessageOptions = [
  {
    value: '[Order #]',
    messageDescriptor: messages.orderNumber,
  },
  {
    value: '[Store Company Name]',
    messageDescriptor: messages.storeCompanyName,
  },
  {
    value: '[Ship Date]',
    messageDescriptor: messages.shipDate,
  },
  {
    value: '[Order Date]',
    messageDescriptor: messages.orderDate,
  },
  {
    value: '[Sku #1]',
    messageDescriptor: messages.sku1,
  },
  {
    value: '[Sku #2]',
    messageDescriptor: messages.sku2,
  },
  {
    value: '[Sku #3]',
    messageDescriptor: messages.sku3,
  },
  {
    value: '[Product #1]',
    messageDescriptor: messages.product1,
  },
  {
    value: '[Product #2]',
    messageDescriptor: messages.product2,
  },
  {
    value: '[Product #3]',
    messageDescriptor: messages.product3,
  },
  {
    value: '[Dimensions]',
    messageDescriptor: messages.dimensions,
  },
  {
    value: '[Weight]',
    messageDescriptor: messages.weight,
  },
  {
    value: '[Notes from Buyer]',
    messageDescriptor: messages.notesFromBuyer,
  },
  {
    value: '[Custom Field #1]',
    messageDescriptor: messages.customField1,
  },
  {
    value: '[Custom Field #2]',
    messageDescriptor: messages.customField2,
  },
  {
    value: '[Custom Field #3]',
    messageDescriptor: messages.customField3,
  },
  {
    value: '[Fill Sku #1]',
    messageDescriptor: messages.fillSku1,
  },
  {
    value: '[Fill Sku #2]',
    messageDescriptor: messages.fillSku2,
  },
  {
    value: '[Fill Sku #3]',
    messageDescriptor: messages.fillSku3,
  },
  {
    value: '[Warehouse Loc #1]',
    messageDescriptor: messages.warehouse1,
  },
  {
    value: '[Warehouse Loc #2]',
    messageDescriptor: messages.warehouse2,
  },
  {
    value: '[Warehouse Loc #3]',
    messageDescriptor: messages.warehouse3,
  },
  {
    value: '[Buyer Name]',
    messageDescriptor: messages.buyerName,
  },
];
